import './App.css';
import { Toaster } from 'sonner';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/Dashboard'; // 대시보드 컴포넌트 임포트

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        {/* 루트 경로: 로그인 상태 확인 후 리다이렉트 */}
        <Route path="/" element={<RootRedirect />} />
        
        {/* 로그인 경로 */}
        <Route path="/login" element={<Login />} />

        {/* 대시보드 경로: 인증이 필요한 서비스 */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        {/* 정의되지 않은 모든 경로는 루트로 이동 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

/**
 * 로그인 여부에 따라 /login 또는 /dashboard로 보내주는 컴포넌트
 */
function RootRedirect() {
  const token = localStorage.getItem('token');
  return <Navigate to={token ? "/dashboard" : "/login"} replace />;
}

/**
 * 로그인하지 않은 사용자가 대시보드 주소를 직접 치고 들어올 때 차단
 */
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  
  if (!token) {
    // 토큰이 없으면 로그인 페이지로 보내버림
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

export default App;